import { defineMessages } from 'react-intl'

export interface Message {
  id: string
  defaultMessage: string
}

export const messages = defineMessages({
  ADDING_ITEMS_TO_CART: {
    id: 'ADDING_ITEMS_TO_CART',
    defaultMessage: 'Adding Items to Cart',
  },
  REDIRECTING_TO_CHECKOUT: {
    id: 'REDIRECTING_TO_CHECKOUT',
    defaultMessage: 'Redirecting to checkout process',
  },
  UPDATING_CART: { id: 'UPDATING_CART', defaultMessage: 'Updating Cart' },
  NAME: { id: 'NAME', defaultMessage: 'Name' },
  LIST_DETAILS: { id: 'LIST_DETAILS', defaultMessage: 'List Details' },
  DESCRIPTION: { id: 'DESCRIPTION', defaultMessage: 'Description' },
  SAVED_CARTS_LIST_CART: {
    id: 'SAVED_CARTS_LIST_CART',
    defaultMessage: 'Cart',
  },
  ITEMS: { id: 'ITEMS', defaultMessage: 'Items' },
  CHECKOUT: { id: 'CHECKOUT', defaultMessage: 'Checkout' },
  ADD_TO_LIST: { id: 'ADD_TO_LIST', defaultMessage: 'Add to List' },
  VIEW_SAVED_CART: { id: 'VIEW_SAVED_CART', defaultMessage: 'View Saved Cart' },
  ORDERS: { id: 'ORDERS', defaultMessage: 'Orders' },
  APPROVE_ORDERS: { id: 'APPROVE_ORDERS', defaultMessage: 'Approve Orders' },
  CONSOLIDATE_CARTS: {
    id: 'CONSOLIDATE_CARTS',
    defaultMessage: 'Consolidate Carts',
  },
  QUOTES_TABS_LABEL: {
    id: 'QUOTES_TABS_LABEL',
    defaultMessage:
      'Allows to select recent quotes (Recent Web Quotes), or add a criteria to search',
  },
  RECENT_QUOTES: {
    id: 'RECENT_QUOTES',
    defaultMessage: 'Recent Quotes',
  },
  ALL_QUOTES: {
    id: 'ALL_QUOTES',
    defaultMessage: 'All Quotes',
  },
  ONLINE_QUOTES: {
    id: 'ONLINE_QUOTES',
    defaultMessage: 'Online Quotes',
  },
  PAYMENT_BY_CREDIT_CARD: {
    id: 'PAYMENT_BY_CREDIT_CARD',
    defaultMessage: 'Payment by Credit Card',
  },
  CC_EMAIL_HELP: {
    id: 'CC_EMAIL_HELP',
    defaultMessage: 'Separate email addresses with a comma.',
  },
  DOWNLOAD: { id: 'DOWNLOAD', defaultMessage: 'Download' },
  PAYMENT_HISTORY: { id: 'PAYMENT_HISTORY', defaultMessage: 'Payment History' },
  DEALER_REQUESTS: { id: 'DEALER_REQUESTS', defaultMessage: 'Dealer Requests' },
  QUOTE_NUMBER: { id: 'QUOTE_NUMBER', defaultMessage: 'Quote Number' },
  QUOTE_NAME_EMPTY: {
    id: 'QUOTE_NAME_EMPTY',
    defaultMessage: 'Add Quote Name',
  },
  QUOTE_NAME_PRESENT: {
    id: 'QUOTE_NAME_PRESENT',
    defaultMessage: 'Edit Quote Name',
  },
  QUOTE_NAME: { id: 'QUOTE_NAME', defaultMessage: 'Quote Name' },
  ADD_NAME: { id: 'ADD_NAME', defaultMessage: 'Add Name' },
  EDIT_NAME: { id: 'EDIT_NAME', defaultMessage: 'Edit Name' },
  EXPIRES: { id: 'EXPIRES', defaultMessage: 'Expires' },
  ORDERED_BY: { id: 'ORDERED_BY', defaultMessage: 'Ordered By' },
  QUOTE_SEARCH: { id: 'QUOTE_SEARCH', defaultMessage: 'Quote Search' },
  BACK_TO_ORDERS: { id: 'BACK_TO_ORDERS', defaultMessage: 'Back to Orders' },
  UNKNOWN_ERROR: { id: 'UNKNOWN_ERROR', defaultMessage: 'Unknown Error' },
  ORDER_CANCEL_HEADER: {
    id: 'ORDER_CANCEL_HEADER',
    defaultMessage: 'Cancel Order',
  },
  ORDER_RETURN_HEADER: {
    id: 'ORDER_RETURN_HEADER',
    defaultMessage: 'Return Product(s)',
  },
  ORDER_CANCEL_DESCRIPTION: {
    id: 'ORDER_CANCEL_DESCRIPTION',
    defaultMessage: 'Please review the order you’d like to cancel.',
  },
  ORDER_CANCEL_ITEMS: {
    id: 'ORDER_CANCEL_ITEMS',
    defaultMessage: 'Order Items',
  },
  ORDER_RETURN_DESCRIPTION: {
    id: 'ORDER_RETURN_DESCRIPTION',
    defaultMessage:
      'Please choose the eligible item(s) you’d like to return. A return request will be initiated with the corresponding seller(s).',
  },
  ORDER_RETURN_SELECT_ITEMS: {
    id: 'ORDER_RETURN_SELECT_ITEMS',
    defaultMessage: 'Select items to return',
  },
  ORDER_RETURN_COLUMN_SELECT: {
    id: 'ORDER_RETURN_COLUMN_SELECT',
    defaultMessage: 'Select',
  },
  ORDER_RETURN_COLUMN_PRODUCT: {
    id: 'ORDER_RETURN_COLUMN_PRODUCT',
    defaultMessage: 'Product',
  },
  ORDER_CANCEL_SHIPPED_AND_SOLD: {
    id: 'ORDER_CANCEL_SHIPPED_AND_SOLD',
    defaultMessage: 'Shipped & Sold by {sellerName}',
  },
  ORDER_RETURN_SHIPPED_AND_SOLD: {
    id: 'ORDER_RETURN_SHIPPED_AND_SOLD',
    defaultMessage: 'Shipped & Sold by {sellerName}',
  },
  QUANTITY: { id: 'QUANTITY', defaultMessage: 'Quantity' },
  ORDER_RETURN_QTY_TO_RETURN: {
    id: 'ORDER_RETURN_QTY_TO_RETURN',
    defaultMessage: 'Quantity to return',
  },
  ORDER_RETURN_WHY: {
    id: 'ORDER_RETURN_WHY',
    defaultMessage: 'Why are you returning this?',
  },
  MIN_3_CHARACTERS: {
    id: 'MIN_3_CHARACTERS',
    defaultMessage: 'Must be 3 characters minimum',
  },
  MAX_50000_CHARACTERS: {
    id: 'MAX_50000_CHARACTERS',
    defaultMessage: 'Must be 50,000 characters max',
  },
  ORDER_RETURN_HOW_ASSIST: {
    id: 'ORDER_RETURN_HOW_ASSIST',
    defaultMessage: 'How can we assist you?',
  },
  SUBMIT: { id: 'SUBMIT', defaultMessage: 'Submit' },
  FAPIAO_NUMBER: { id: 'FAPIAO_NUMBER', defaultMessage: 'Fapiao Number' },
  FAPIAO_PREVIEW_DOWNLOAD: {
    id: 'FAPIAO_PREVIEW_DOWNLOAD',
    defaultMessage: 'Preview or Download E-Fapiao',
  },
  FAPIAO_CARRIER_NAME: {
    id: 'FAPIAO_CARRIER_NAME',
    defaultMessage: 'Carrier Name',
  },
  FAPIAO_TRACKING_NUMBER: {
    id: 'FAPIAO_TRACKING_NUMBER',
    defaultMessage: 'Tracking No.',
  },
  FAPIAO_ISSUE_DATE: { id: 'FAPIAO_ISSUE_DATE', defaultMessage: 'Issue Date' },
  FAPIAO_AMOUNT: { id: 'FAPIAO_AMOUNT', defaultMessage: 'Amount' },
  FAPIAO_TITLE: { id: 'FAPIAO_TITLE', defaultMessage: 'Fapiao Title' },
  FAPIAO_TAX_LISCENSE: {
    id: 'FAPIAO_TAX_LISCENSE',
    defaultMessage: 'Tax License',
  },
  FAPIAO_TYPE: { id: 'FAPIAO_TYPE', defaultMessage: 'Fapiao Type' },
  FULL_REGISTRATION_TAX_ELECTRONIC_PLAIN_VALUE_ADDED_TAX_INVOICES: {
    id: 'FULL_REGISTRATION_TAX_ELECTRONIC_PLAIN_VALUE_ADDED_TAX_INVOICES',
    defaultMessage: 'Electronic Plain Value-Added Tax Invoices',
  },
  FULL_REGISTRATION_TAX_VALUE_ADDED_TAX_INVOICES: {
    id: 'FULL_REGISTRATION_TAX_VALUE_ADDED_TAX_INVOICES',
    defaultMessage: 'Value-Added Tax Invoices',
  },
  VALID_DATE_RANGE: {
    id: 'VALID_DATE_RANGE',
    defaultMessage: 'Please use a valid date range.',
  },
  DATE_RANGE_CANNOT_BE_GT_31DAYS: {
    id: 'DATE_RANGE_CANNOT_BE_GT_31DAYS',
    defaultMessage: 'Date range should not be greater than 31 days.',
  },
  DATE_CANNOT_BE_GT_TODAY: {
    id: 'DATE_CANNOT_BE_GT_TODAY',
    defaultMessage: 'Please use a valid date range',
  },
  FAPIAO_ISSUED_FROM: {
    id: 'FAPIAO_ISSUED_FROM',
    defaultMessage: 'Issued From',
  },
  FAPIAO_ISSUED_TO: { id: 'FAPIAO_ISSUED_TO', defaultMessage: 'Issued To' },
  SHOW_ALL: {
    id: 'SHOW_ALL',
    defaultMessage: 'Show All',
  },
  SHOW_MY_ORDERS: {
    id: 'SHOW_MY_ORDERS',
    defaultMessage: 'Show only my orders',
  },
  ORDER_COUNT_SHOWN: {
    id: 'ORDER_COUNT_SHOWN',
    defaultMessage: 'Showing {amount} of your orders',
  },
  NUM_ORDERS: {
    id: 'NUM_ORDERS',
    defaultMessage: '{amount} orders',
  },
  SHOW_LESS: { id: 'SHOW_LESS', defaultMessage: 'Show Less' },
  SHOW_MORE: { id: 'SHOW_MORE', defaultMessage: 'Show More' },
  CART_ID: { id: 'CART_ID', defaultMessage: 'Cart ID' },
  SUBMITTED: { id: 'SUBMITTED', defaultMessage: 'Submitted' },
  REQUESTOR: { id: 'REQUESTOR', defaultMessage: 'Requestor' },
  DELETE_SELECTED_CARTS: {
    id: 'DELETE_SELECTED_CARTS',
    defaultMessage: 'Delete Selected Carts',
  },
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_CONSOLIDATION_CART: {
    id: 'ARE_YOU_SURE_YOU_WANT_TO_DELETE_CONSOLIDATION_CART',
    defaultMessage: 'Are you sure you want to delete {cartCount} cart(s)?',
  },
  CANCEL: { id: 'CANCEL', defaultMessage: 'Cancel' },
  DELETE: { id: 'DELETE', defaultMessage: 'Delete' },
  BILL_TO: { id: 'BILL_TO', defaultMessage: 'Bill To' },
  SHIP_TO: { id: 'SHIP_TO', defaultMessage: 'Ship To' },
  HIDE_CARTS: { id: 'HIDE_CARTS', defaultMessage: 'Hide Carts' },
  SHOW_CARTS: { id: 'SHOW_CARTS', defaultMessage: 'Show Carts' },
  LOAD_ALL_CARTS: { id: 'LOAD_ALL_CARTS', defaultMessage: 'Load All Carts' },
  LOAD_SELECTED_CARTS: {
    id: 'LOAD_SELECTED_CARTS',
    defaultMessage: 'Load Selected Carts',
  },
  NO_CARTS_TO_CONSOLIDATE: {
    id: 'NO_CARTS_TO_CONSOLIDATE',
    defaultMessage: 'There are no pending carts to consolidate.',
  },
  CLEAR_ALL: { id: 'CLEAR_ALL', defaultMessage: 'Clear All' },
  order_search_organization: {
    id: 'order_search_organization',
    defaultMessage: 'Organization',
  },
  order_search_ship_to: {
    id: 'order_search_ship_to',
    defaultMessage: 'Ship To',
  },
  NO_END_USER: { id: 'NO_END_USER', defaultMessage: 'No End User' },
  CONTACT_PARTY: { id: 'CONTACT_PARTY', defaultMessage: 'Contact Party' },
  PRODUCT_SKU: { id: 'PRODUCT_SKU', defaultMessage: 'Product SKU' },
  QUOTE_STATUS: { id: 'QUOTE_STATUS', defaultMessage: 'Quote Status' },
  CREATED_ON_OR_AFTER: {
    id: 'CREATED_ON_OR_AFTER',
    defaultMessage: 'Created on or after',
  },
  EXPIRES_ON_OR_BEFORE: {
    id: 'EXPIRES_ON_OR_BEFORE',
    defaultMessage: 'Expires on or before',
  },
  SEARCH_ORDERS_SHORT: { id: 'SEARCH_ORDERS_SHORT', defaultMessage: 'Search' },
  QUOTE_SEARCH_TOOLS: {
    id: 'QUOTE_SEARCH_TOOLS',
    defaultMessage: 'Use search tools to find quotes.',
  },
  REQUEST_NEW_QUOTE: {
    id: 'REQUEST_NEW_QUOTE',
    defaultMessage: 'Request New Quote',
  },
  GENERATE_A_QUOTE: {
    id: 'GENERATE_A_QUOTE',
    defaultMessage: 'Generate a Quote',
  },
  QUOTE_DETAILS: { id: 'QUOTE_DETAILS', defaultMessage: 'Quote Details' },
  QUOTE_BILLING_ADDRESS: {
    id: 'QUOTE_BILLING_ADDRESS',
    defaultMessage: 'Billing Address',
  },
  QUOTE_SHIPPING_ADDRESS: {
    id: 'QUOTE_SHIPPING_ADDRESS',
    defaultMessage: 'Shipping Address',
  },
  CREATED_DATE: { id: 'CREATED_DATE', defaultMessage: 'Created Date' },
  QUOTE_CSR_INSTRUCTIONS: {
    id: 'QUOTE_CSR_INSTRUCTIONS',
    defaultMessage: 'Customer Service Instructions',
  },
  QUOTE_PO_NUMBER: { id: 'QUOTE_PO_NUMBER', defaultMessage: 'PO Number' },
  REQUISITION_NUMBER: {
    id: 'REQUISITION_NUMBER',
    defaultMessage: 'Requisition Number',
  },
  ERROR: {
    id: 'ERROR',
    defaultMessage: 'Error',
  },
  PENDING_APPROVAL: {
    id: 'PENDING_APPROVAL',
    defaultMessage: 'Pending Approval',
  },
  PENDING_REVIEW: {
    id: 'PENDING_REVIEW',
    defaultMessage: 'Pending Review',
  },
  WIMS_ORDER_STATUS_OPEN: {
    id: 'WIMS_ORDER_STATUS_OPEN',
    defaultMessage: 'New',
  },
  WIMS_ORDER_STATUS_EMPTY: {
    id: 'WIMS_ORDER_STATUS_EMPTY',
    defaultMessage: 'Open',
  },
  WIMS_ORDER_STATUS_A: { id: 'WIMS_ORDER_STATUS_A', defaultMessage: 'New' },
  WIMS_ORDER_STATUS_B: {
    id: 'WIMS_ORDER_STATUS_B',
    defaultMessage: 'In Process',
  },
  WIMS_ORDER_STATUS_C: {
    id: 'WIMS_ORDER_STATUS_C',
    defaultMessage: 'Complete',
  },
  WIMS_ORDER_STATUS_G: { id: 'WIMS_ORDER_STATUS_G', defaultMessage: 'Pending' },
  WIMS_ORDER_STATUS_CANCELLED: {
    id: 'WIMS_ORDER_STATUS_CANCELLED',
    defaultMessage: 'Cancelled',
  },
  WIMS_ORDER_STATUS_R: {
    id: 'WIMS_ORDER_STATUS_R',
    defaultMessage: 'Rejected',
  },
  WIMS_ORDER_STATUS_OH: {
    id: 'WIMS_ORDER_STATUS_OH',
    defaultMessage: 'On Hold',
  },
  QUOTE: { id: 'QUOTE', defaultMessage: 'Quote' },
  EXPIRED: { id: 'EXPIRED', defaultMessage: 'Expired' },
  CONVERT_TO_ORDER: {
    id: 'CONVERT_TO_ORDER',
    defaultMessage: 'Convert To Order',
  },
  QUOTE_CONFIRM_CONVERT_ALL: {
    id: 'QUOTE_CONFIRM_CONVERT_ALL',
    defaultMessage:
      'Are you sure you want to convert all quantities on this quote to an order?',
  },
  AGREE: { id: 'AGREE', defaultMessage: 'Agree' },
  BACK_TO_QUOTES: { id: 'BACK_TO_QUOTES', defaultMessage: 'Back to Quotes' },
  DIGITAL_PRODUCT_CART_MIXING_ERROR: {
    id: 'DIGITAL_PRODUCT_CART_MIXING_ERROR',
    defaultMessage:
      'Software items cannot be added to the cart with other items. There are products in your cart already. Please complete your existing purchase or remove the items to continue.',
  },
  QUOTE_ITEM_PRESS_REQUEST: {
    id: 'QUOTE_ITEM_PRESS_REQUEST',
    defaultMessage:
      "Press the 'Request New Quote' button to generate a new quote for the items listed",
  },
  QUOTE_ITEM_MODIFY: {
    id: 'QUOTE_ITEM_MODIFY',
    defaultMessage:
      'Modify the quantity box for each product and then click the "Add To Cart" to convert the Quote into an Order',
  },
  ADDITIONAL_INFO_POPOVER: {
    id: 'ADDITIONAL_INFO_POPOVER',
    defaultMessage: 'View Additional Information',
  },
  QUOTE_ITEM: { id: 'QUOTE_ITEM', defaultMessage: 'Quote Item' },
  SHIPPING_DATE_TO_BE_DETERMINED: {
    id: 'SHIPPING_DATE_TO_BE_DETERMINED',
    defaultMessage: 'Shipping date to be determined',
  },
  QUANTITY_REMAINING: {
    id: 'QUANTITY_REMAINING',
    defaultMessage: 'Quantity Remaining',
  },
  LOT_NUMBER: { id: 'LOT_NUMBER', defaultMessage: 'Lot Number' },
  PRODUCT_NOTE: { id: 'PRODUCT_NOTE', defaultMessage: 'Packing Slip Note' },
  YOUR_REFERENCE: { id: 'YOUR_REFERENCE', defaultMessage: 'Your Reference' },
  SPECIFICATION_SHEET: {
    id: 'SPECIFICATION_SHEET',
    defaultMessage: 'Specification Sheet',
  },
  VIEW_PDF: { id: 'VIEW_PDF', defaultMessage: 'View PDF' },
  GENERAL: { id: 'GENERAL', defaultMessage: 'General' },
  ITEM_AMOUNT: { id: 'ITEM_AMOUNT', defaultMessage: 'Item Amount' },
  TOTAL_AMOUNT: { id: 'TOTAL_AMOUNT', defaultMessage: 'Total Amount' },
  APPROVE_SELECTED: {
    id: 'APPROVE_SELECTED',
    defaultMessage: 'Approve Selected',
  },
  ORDER: { id: 'ORDER', defaultMessage: 'Order' },
  PO: { id: 'PO', defaultMessage: 'PO' },
  TYPE: { id: 'TYPE', defaultMessage: 'Type' },
  AMOUNT_LIMIT: { id: 'AMOUNT_LIMIT', defaultMessage: 'Amount Limit' },
  AMOUNT: { id: 'AMOUNT', defaultMessage: 'Amount' },
  REVIEW: { id: 'REVIEW', defaultMessage: 'Review' },
  APPROVE: { id: 'APPROVE', defaultMessage: 'Approve' },
  ORDER_SEARCH_TOOLS: {
    id: 'ORDER_SEARCH_TOOLS',
    defaultMessage: 'Use search tools to find orders.',
  },
  ORDERED_TYPE: { id: 'ORDERED_TYPE', defaultMessage: 'Order Type' },
  ORDER_SEARCH: { id: 'ORDER_SEARCH', defaultMessage: 'Order Search' },
  EXPORT_LIST: { id: 'EXPORT_LIST', defaultMessage: 'Export List' },
  SHEET: { id: 'SHEET', defaultMessage: 'Sheet' },
  SEARCH_ORDERS: { id: 'SEARCH_ORDERS', defaultMessage: 'Search Orders' },
  WIMS_AUTH_ERROR_TEXT: {
    id: 'WIMS_AUTH_ERROR_TEXT',
    defaultMessage:
      'Your {companyName} authentication has expired or has been rejected.{link}',
  },
  WIMS_AUTH_ERROR_LINK: {
    id: 'WIMS_AUTH_ERROR_LINK',
    defaultMessage: 'Click to login in again.',
  },
  WIMS_AUTH_SUCCESS_TEXT: {
    id: 'WIMS_AUTH_SUCCESS_TEXT',
    defaultMessage:
      'You have successfully linked your {companyName} Millipore account. You may search orders below. Manage this linked profile in your pofile',
  },
  CLEAR_ORDER_SEARCH: { id: 'CLEAR_ORDER_SEARCH', defaultMessage: 'Clear All' },
  ORDER_STATUS: { id: 'ORDER_STATUS', defaultMessage: 'Order Status' },
  FROM: { id: 'FROM', defaultMessage: 'From' },
  TO: { id: 'TO', defaultMessage: 'To' },
  WIMS_ORDER_LINKING_TEXT: {
    id: 'WIMS_ORDER_LINKING_TEXT',
    defaultMessage: 'View your {companyName} orders on SigmaAldrich.com.{link}',
  },
  WIMS_ORDER_LINKING_LINK: {
    id: 'WIMS_ORDER_LINKING_LINK',
    defaultMessage: 'Login to {companyUrl} to link your orders.',
  },
  CREATE_NEW_ORDER: {
    id: 'CREATE_NEW_ORDER',
    defaultMessage: 'Create New Order',
  },
  LIST: { id: 'LIST', defaultMessage: 'List' },
  LIST_NAME_PLACEHOLDER: {
    id: 'LIST_NAME_PLACEHOLDER',
    defaultMessage: 'University Biology Shared List',
  },
  LIST_NAME: { id: 'LIST_NAME', defaultMessage: 'List Name' },
  LIST_DESCRIPTION_PLACEHOLDER: {
    id: 'LIST_DESCRIPTION_PLACEHOLDER',
    defaultMessage: 'Collective List for Biology Department',
  },
  LIST_DESCRIPTION: {
    id: 'LIST_DESCRIPTION',
    defaultMessage: 'List Description',
  },
  EDIT_LIST: {
    id: 'EDIT_LIST',
    defaultMessage: 'Edit List',
  },
  DELETE_LIST: {
    id: 'DELETE_LIST',
    defaultMessage: 'Delete List',
  },
  DUPLICATE_LIST: {
    id: 'DUPLICATE_LIST',
    defaultMessage: 'Duplicate List',
  },
  LEAVE_LIST: {
    id: 'LEAVE_LIST',
    defaultMessage: 'Leave List',
  },
  SAVE: { id: 'SAVE', defaultMessage: 'Save' },
  ADD: { id: 'ADD', defaultMessage: 'Add' },
  LIST_LEFT: { id: 'LIST_LEFT', defaultMessage: 'You\'ve left "{listName}"' },
  LEAVE_FIELD: { id: 'LEAVE_FIELD', defaultMessage: 'Leave {field}' },
  REMOVE_MEMBER: { id: 'REMOVE_MEMBER', defaultMessage: 'Remove member' },
  CONFIRM_LEAVE_LIST: {
    id: 'CONFIRM_LEAVE_LIST',
    defaultMessage:
      'Are you sure? You will have to be re-invited by the list owner to view or contribute to this list.',
  },
  CONFIRM_REMOVE_MEMBER: {
    id: 'CONFIRM_REMOVE_MEMBER',
    defaultMessage:
      'Are you sure? You will have to re-invite this member once removed.',
  },
  REMOVE: { id: 'REMOVE', defaultMessage: 'Remove' },
  VIEW_LIST: { id: 'VIEW_LIST', defaultMessage: 'View list' },
  YOU: { id: 'YOU', defaultMessage: 'You' },
  LAST_UPDATED: { id: 'LAST_UPDATED', defaultMessage: 'Last Updated' },
  SHARED: { id: 'SHARED', defaultMessage: 'Shared' },
  PRIVATE: { id: 'PRIVATE', defaultMessage: 'Private' },
  DUPLICATE_FIELD: {
    id: 'DUPLICATE_FIELD',
    defaultMessage: 'Duplicate {field}',
  },
  DELETE_FIELD: { id: 'DELETE_FIELD', defaultMessage: 'Delete {field}' },
  ALPHABETICAL_ORDER: {
    id: 'ALPHABETICAL_ORDER',
    defaultMessage: 'Alphabetical Order',
  },
  DATE_CREATED: { id: 'DATE_CREATED', defaultMessage: 'Date Created' },
  LISTS_DESCRIPTION: {
    id: 'LISTS_DESCRIPTION',
    defaultMessage:
      'Use lists to save items for later or share your lists to collaborate with others.',
  },
  CREATE_LIST: { id: 'CREATE_LIST', defaultMessage: 'Create List' },
  LOADING: { id: 'LOADING', defaultMessage: 'Loading' },
  CREATE_A_LIST_VERBOSE: {
    id: 'CREATE_A_LIST_VERBOSE',
    defaultMessage: 'Create a Sharable Shopping List',
  },
  INVITE_MEMBERS_HELP: {
    id: 'INVITE_MEMBERS_HELP',
    defaultMessage:
      'Invite colleagues to contribute to your shopping list for group orders.',
  },
  INVITE_MEMBERS_HELP_2: {
    id: 'INVITE_MEMBERS_HELP_2',
    defaultMessage:
      'Leave notes on important products for buyers and view comments from other collaborators.',
  },
  CREATE_A_LIST: { id: 'CREATE_A_LIST', defaultMessage: 'Create a List' },
  CART_CC_ERROR_MSG: {
    id: 'CART_CC_ERROR_MSG',
    defaultMessage: 'Please separate email addresses with commas.',
  },
  LIST_CREATED: { id: 'LIST_CREATED', defaultMessage: 'List created' },
  LIST_DELETED: { id: 'LIST_DELETED', defaultMessage: 'List deleted' },
  CONFIRM_DELETE_LIST: {
    id: 'CONFIRM_DELETE_LIST',
    defaultMessage:
      'Are you sure you want to delete this list? This action cannot be undone.',
  },
  MARKETPLACE_RETURN_ITEMS: {
    id: 'MARKETPLACE_RETURN_ITEMS',
    defaultMessage: 'Return Product(s)',
  },
  MARKETPLACE_CANCEL_ORDER: {
    id: 'MARKETPLACE_CANCEL_ORDER',
    defaultMessage: 'Cancel Order',
  },
  REPURCHASE_ORDER: {
    id: 'REPURCHASE_ORDER',
    defaultMessage: 'Repurchase Order',
  },
  ADD_ALL_TO_CART: {
    id: 'ADD_ALL_TO_CART',
    defaultMessage: 'Add All to Cart',
  },
  ORDER_LEAVE_FEEDBACK: {
    id: 'ORDER_LEAVE_FEEDBACK',
    defaultMessage: 'Leave Feedback For {sellerName}',
  },
  ORDER_OVERALL_RATING_MPP_SCORE: {
    id: 'ORDER_OVERALL_RATING_MPP_SCORE',
    defaultMessage: '* Overall Rating',
  },
  ORDER_SHARE_EXPERIENCE: {
    id: 'ORDER_SHARE_EXPERIENCE',
    defaultMessage: 'Please share your experience with this seller.',
  },
  ORDER_REQUIRED: { id: 'ORDER_REQUIRED', defaultMessage: '* Required Field' },
  ORDER_COMMENTS: { id: 'ORDER_COMMENTS', defaultMessage: '* Comments' },
  ORDER_COMMENTS_50_CHAR_MIN: {
    id: 'ORDER_COMMENTS_50_CHAR_MIN',
    defaultMessage: 'Must be 50 characters minimum',
  },
  ORDER_READ_AND_AGREE: {
    id: 'ORDER_READ_AND_AGREE',
    defaultMessage: '* I have read and agree to the',
  },
  WIMS_ORDER_ITEM_SHIP_STATUS_OPEN: {
    id: 'WIMS_ORDER_ITEM_SHIP_STATUS_OPEN',
    defaultMessage: 'Estimated Ship Date',
  },
  WIMS_ORDER_ITEM_SHIP_STATUS_EMPTY: {
    id: 'WIMS_ORDER_ITEM_SHIP_STATUS_EMPTY',
    defaultMessage: 'Pending',
  },
  WIMS_ORDER_ITEM_SHIP_STATUS_PENDING: {
    id: 'WIMS_ORDER_ITEM_SHIP_STATUS_PENDING',
    defaultMessage: 'Pending',
  },
  WIMS_ORDER_ITEM_SHIP_STATUS_SHIPPED: {
    id: 'WIMS_ORDER_ITEM_SHIP_STATUS_SHIPPED',
    defaultMessage: 'Shipped',
  },
  WIMS_ORDER_ITEM_SHIP_STATUS_COMPLETED: {
    id: 'WIMS_ORDER_ITEM_SHIP_STATUS_COMPLETED',
    defaultMessage: 'Shipped',
  },
  WIMS_ORDER_ITEM_SHIP_STATUS_INVOICED: {
    id: 'WIMS_ORDER_ITEM_SHIP_STATUS_INVOICED',
    defaultMessage: 'Invoiced. Shipped',
  },
  WIMS_ORDER_ITEM_SHIP_STATUS_CANCELLED: {
    id: 'WIMS_ORDER_ITEM_SHIP_STATUS_CANCELLED',
    defaultMessage: 'Cancelled',
  },
  WIMS_ORDER_ITEM_SHIP_STATUS_REFUNDED: {
    id: 'WIMS_ORDER_ITEM_SHIP_STATUS_REFUNDED',
    defaultMessage: 'Refunded on',
  },
  WIMS_ORDER_ITEM_SHIP_STATUS_PENDING_REFUND: {
    id: 'WIMS_ORDER_ITEM_SHIP_STATUS_PENDING_REFUND',
    defaultMessage: 'Pending Refund on',
  },
  WIMS_ORDER_STATUS_AP: {
    id: 'WIMS_ORDER_STATUS_AP',
    defaultMessage: 'Pending Approval',
  },
  WIMS_ORDER_STATUS_RE: {
    id: 'WIMS_ORDER_STATUS_RE',
    defaultMessage: 'Pending Review',
  },
  WIMS_ORDER_ITEM_SHIP_STATUS_PENDING_DROP_SHIP: {
    id: 'WIMS_ORDER_ITEM_SHIP_STATUS_PENDING_DROP_SHIP',
    defaultMessage: 'Pending: Item will ship directly from the manufacturer',
  },
  WIMS_ORDER_ITEM_SHIP_STATUS_COMPLETED_DROP_SHIP: {
    id: 'WIMS_ORDER_ITEM_SHIP_STATUS_COMPLETED_DROP_SHIP',
    defaultMessage: 'Complete: Item has shipped from the manufacturer',
  },
  WIMS_ORDER_ITEM_SHIP_STATUS_CANCELLED_DROP_SHIP: {
    id: 'WIMS_ORDER_ITEM_SHIP_STATUS_CANCELLED_DROP_SHIP',
    defaultMessage: 'Canceled: Contact customer service for more information',
  },
  WIMS_ORDER_ITEM_SHIP_STATUS_IN_PROCESS: {
    id: 'WIMS_ORDER_ITEM_SHIP_STATUS_IN_PROCESS',
    defaultMessage: 'In Process',
  },
  WIMS_ORDER_ITEM_SHIP_STATUS_PROCESSING: {
    id: 'WIMS_ORDER_ITEM_SHIP_STATUS_PROCESSING',
    defaultMessage: 'Processing',
  },
  WIMS_ORDER_ITEM_SHIP_STATUS_CLOSED: {
    id: 'WIMS_ORDER_ITEM_SHIP_STATUS_CLOSED',
    defaultMessage: 'Closed',
  },
  WIMS_ORDER_ITEM_SHIP_STATUS_PARTIALLY_CANCELLED: {
    id: 'WIMS_ORDER_ITEM_SHIP_STATUS_PARTIALLY_CANCELLED',
    defaultMessage: 'Partially cancelled',
  },
  WIMS_ORDER_ITEM_SHIP_STATUS_PARTIALLY_RECEIVED: {
    id: 'WIMS_ORDER_ITEM_SHIP_STATUS_PARTIALLY_RECEIVED',
    defaultMessage: 'Partially received',
  },
  WIMS_ORDER_ITEM_SHIP_STATUS_PARTIALLY_SHIPPED: {
    id: 'WIMS_ORDER_ITEM_SHIP_STATUS_PARTIALLY_SHIPPED',
    defaultMessage: 'Partially shipped',
  },
  WIMS_ORDER_ITEM_SHIP_STATUS_RECEIVED: {
    id: 'WIMS_ORDER_ITEM_SHIP_STATUS_RECEIVED',
    defaultMessage: 'Received',
  },
  WIMS_ORDER_ITEM_SHIP_STATUS_SHIPPING_IN_PROGRESS: {
    id: 'WIMS_ORDER_ITEM_SHIP_STATUS_SHIPPING_IN_PROGRESS',
    defaultMessage: 'Shipping in progress',
  },
  SHIPPED_FROM: { id: 'SHIPPED_FROM', defaultMessage: 'Shipped From' },
  LOT_BATCH: { id: 'LOT_BATCH', defaultMessage: 'Lot/Batch' },
  TRACKING_ID: { id: 'TRACKING_ID', defaultMessage: 'Tracking ID' },
  DELIVERY_ID: { id: 'DELIVERY_ID', defaultMessage: 'Delivery ID' },
  FAPIAO: { id: 'FAPIAO', defaultMessage: 'Fapiao' },
  NOT_APPLICABLE: { id: 'NOT_APPLICABLE', defaultMessage: 'N/A' },
  TRACK_SHIPMENT: { id: 'TRACK_SHIPMENT', defaultMessage: 'Track Shipment' },
  TRACK_SHIPMENT_NOT_PROVIDED: {
    id: 'TRACK_SHIPMENT_NOT_PROVIDED',
    defaultMessage: 'Not Provided',
  },
  PRODUCT_AVAILABILITY_NOT_CALCULATED: {
    id: 'PRODUCT_AVAILABILITY_NOT_CALCULATED',
    defaultMessage:
      'Product Availability: You will receive an order acknowledgement once the order has been entered in our system.',
  },
  VIEW_FAPIAO_DETAILS: {
    id: 'VIEW_FAPIAO_DETAILS',
    defaultMessage: 'View Details',
  },
  QUICK_LINKS: { id: 'QUICK_LINKS', defaultMessage: 'Quick Links' },
  ORDER_SUMMARY: { id: 'ORDER_SUMMARY', defaultMessage: 'Order Summary' },
  SELLER_CONTACT_SELLER: {
    id: 'SELLER_CONTACT_SELLER',
    defaultMessage: 'Contact Seller',
  },
  LEAVE_SELLER_FEEDBACK: {
    id: 'LEAVE_SELLER_FEEDBACK',
    defaultMessage: 'Leave Seller Feedback',
  },
  ABOUT_THIS_SELLER: {
    id: 'ABOUT_THIS_SELLER',
    defaultMessage: 'About This Seller',
  },
  SHIPPED_DATE: { id: 'SHIPPED_DATE', defaultMessage: 'Shipped Date' },
  CARRIER: { id: 'CARRIER', defaultMessage: 'Carrier' },
  TRACKING: { id: 'TRACKING', defaultMessage: 'Tracking' },
  UPDATE_PENDING: { id: 'UPDATE_PENDING', defaultMessage: 'Update Pending' },
  DELIVERY: { id: 'DELIVERY', defaultMessage: 'Delivery' },
  WIMS_ORDER_ITEM_SHIP_STATUS_DELAYED: {
    id: 'WIMS_ORDER_ITEM_SHIP_STATUS_DELAYED',
    defaultMessage:
      'Please contact your local {customerservice} for further information',
  },
  EMAIL: { id: 'EMAIL', defaultMessage: 'Email' },
  PRINT: { id: 'PRINT', defaultMessage: 'Print' },
  ORDER_TRACKING_ORDER_STATUS_NO_RECORD: {
    id: 'ORDER_TRACKING_ORDER_STATUS_NO_RECORD',
    defaultMessage: '抱歉，系统暂未获取到物流轨迹信息。',
  },
  ORDER_TRACKING_URL_MESSAGE: {
    id: 'ORDER_TRACKING_URL_MESSAGE',
    defaultMessage: '您也可以通过以下链接继续查询',
  },
  COPIED: { id: 'COPIED', defaultMessage: 'Copied' },
  ORDER_TRACKING_DETAILS: {
    id: 'ORDER_TRACKING_DETAILS',
    defaultMessage: '物流详情',
  },
  ORDER_FEEDBACK_DONE: {
    id: 'ORDER_FEEDBACK_DONE',
    defaultMessage: 'Done! Thank you for your feedback.',
  },
  ORDER_FEEDBACK_DONE_BODY: {
    id: 'ORDER_FEEDBACK_DONE_BODY',
    defaultMessage:
      'Your feedback will be used to improve future Marketplace experiences.',
  },
  ORDER_FEEDBACK_DONE_RETURN: {
    id: 'ORDER_FEEDBACK_DONE_RETURN',
    defaultMessage: 'Return to Order History',
  },
  ORDER_REQUEST: { id: 'ORDER_REQUEST', defaultMessage: 'Request' },
  ORDER_DATE: { id: 'ORDER_DATE', defaultMessage: 'Order Date' },
  DEALER_REQUEST_DISCLAIMER_TEXT: {
    id: 'DEALER_REQUEST_DISCLAIMER_TEXT',
    defaultMessage:
      'For questions on order status, please contact the Dealer Selected for this request or',
  },
  EMPROVE_ORDER_REQUEST: {
    id: 'EMPROVE_ORDER_REQUEST',
    defaultMessage: 'Request',
  },
  EMPROVE_ORDER_PENDING_STATUS_APPROVAL_TEXT: {
    id: 'EMPROVE_ORDER_PENDING_STATUS_APPROVAL_TEXT',
    defaultMessage: 'Your order is pending for approval',
  },
  EMPROVE_ORDER_PENDING_STATUS_TEXT: {
    id: 'EMPROVE_ORDER_PENDING_STATUS_TEXT',
    defaultMessage:
      ' Emprove® Dossiers contain confidential information for pharmaceutical producers. Access to your purchase will be granted only after we determine your status as a pharmaceutical producer. We will contact you by email with the next steps. If you have any questions, please contact',
  },
  PENDING_ORDER: { id: 'PENDING_ORDER', defaultMessage: 'Pending Order' },
  MARKETPLACE_ORDER: {
    id: 'MARKETPLACE_ORDER',
    defaultMessage: 'Marketplace Order',
  },
  ORDER_SHIPPING_STATUS: {
    id: 'ORDER_SHIPPING_STATUS',
    defaultMessage: 'Shipping Status',
  },
  ORDER_SHIPPING_STATUS_CLOSE: {
    id: 'ORDER_SHIPPING_STATUS_CLOSE',
    defaultMessage: 'Close',
  },
  ORDER_DETAILS: { id: 'ORDER_DETAILS', defaultMessage: 'Order Details' },
  IN_REVIEW_MESSAGE: {
    id: 'IN_REVIEW_MESSAGE',
    defaultMessage:
      "Your order is under review. When you've been approved to order online, you will receive an email confirmation with your order number. Questions? Please call Customer Service",
  },
  ORDER_PRICE_DISCLAIMER: {
    id: 'ORDER_PRICE_DISCLAIMER',
    defaultMessage:
      'Information related to price, availability and delivery dates is valid at the time of order creation but does not consider delays due to manual processing due to address changes or order comments added in the cart or additional review due to credit, compliance or dangerous goods restrictions.',
  },
  RECIPIENT_CONTACT: {
    id: 'RECIPIENT_CONTACT',
    defaultMessage: 'Recipient Contact',
  },
  ORDER_BILLING_ADDRESS: {
    id: 'ORDER_BILLING_ADDRESS',
    defaultMessage: 'Billing Address',
  },
  PACKING_SLIP_NOTE: {
    id: 'PACKING_SLIP_NOTE',
    defaultMessage: 'Packing Slip Note',
  },
  CUSTOMER_SERVICE_NOTE: {
    id: 'CUSTOMER_SERVICE_NOTE',
    defaultMessage: 'Customer Service Note',
  },
  DEALER_SELECTED: { id: 'DEALER_SELECTED', defaultMessage: 'Dealer Selected' },
  CUSTOMER_PO_NUMBER: {
    id: 'CUSTOMER_PO_NUMBER',
    defaultMessage: 'Customer PO Number',
  },
  CREDIT_CARD: {
    id: 'CC_ENDING_IN',
    defaultMessage:
      '{type, select,\n      VI {Visa}\n      MC {MasterCard}\n      AX {American Express}\n      other {Credit Card}\n    } ending in {number}',
  },
  ACCOUNTING_DOC: {
    id: 'ACCOUNTING_DOC',
    defaultMessage: 'Accounting Doc',
  },
  DOC_TYPE: {
    id: 'DOC_TYPE',
    defaultMessage: 'Doc Type',
  },
  PAST_DUE: {
    id: 'PAST_DUE',
    defaultMessage: 'Past Due',
  },
  VIEW_PAY_SELECTED_INVOICES: {
    id: 'VIEW_PAY_SELECTED_INVOICES',
    defaultMessage: 'View/Pay Selected Invoices',
  },
  SELECTED_INVOICES: {
    id: 'SELECTED_INVOICES',
    defaultMessage: 'Selected Invoices',
  },
  ALL_INVOICES: {
    id: 'ALL_INVOICES',
    defaultMessage: 'All Invoices',
  },
  PHONE_NUMBER_MANDATORY: {
    id: 'PHONE_NUMBER_MANDATORY',
    defaultMessage:
      'Phone number is mandatory for payment, kindly update it in your user account',
  },
  INVOICE_COMMENT_LIMIT: {
    id: 'INVOICE_COMMENT_LIMIT',
    defaultMessage: '60 characters max',
  },
  ADD_EDIT_COMMENT: {
    id: 'ADD_EDIT_COMMENT',
    defaultMessage: 'Add/edit comment',
  },
  PARTIAL_PAYMENT_INFO: {
    id: 'PARTIAL_PAYMENT_INFO',
    defaultMessage: 'Enter the amount you wish to pay.',
  },
  ADD_COMMENT_INFO: {
    id: 'ADD_COMMENT_INFO',
    defaultMessage: 'Click to add a comment.',
  },
  COMMENT_INFO: {
    id: 'COMMENT_INFO',
    defaultMessage: 'Required for partial payment.',
  },
  REQUIRE_COMMENT_ALERT: {
    id: 'REQUIRE_COMMENT_ALERT',
    defaultMessage:
      'A comment is required when submitting a partial payment. Please click any + icons highlighted in red below to add a comment, and then try the Proceed to Payment button again.',
  },
  TDS: {
    id: 'TDS',
    defaultMessage: 'TDS',
  },
  PARTIAL_PAYMENT: {
    id: 'PARTIAL_PAYMENT',
    defaultMessage: 'Partial Payment',
  },
  COMMENT: {
    id: 'COMMENT',
    defaultMessage: 'Comment',
  },
  NET_PAYMENT: {
    id: 'NET_PAYMENT',
    defaultMessage: 'Net Payment',
  },
  REMAINING_AMOUNT: {
    id: 'REMAINING_AMOUNT',
    defaultMessage: 'Remaining Amount',
  },
  INVOICE_AMOUNT: {
    id: 'INVOICE_AMOUNT',
    defaultMessage: 'Invoice Amount',
  },
  PROCEED_TO_PAYMENT: {
    id: 'PROCEED_TO_PAYMENT',
    defaultMessage: 'Proceed to Payment',
  },
  INVOICE_LIST: {
    id: 'INVOICE_LIST',
    defaultMessage: 'Invoice List',
  },
  BACK_TO_INVOICES: {
    id: 'BACK_TO_INVOICES',
    defaultMessage: 'Back to Invoices',
  },
  PAYMENT_TOTAL: {
    id: 'PAYMENT_TOTAL',
    defaultMessage: 'Payment Total',
  },
  INVOICE_PAYMENT: {
    id: 'INVOICE_PAYMENT',
    defaultMessage: 'Invoice Payment',
  },
  MPOWER_NUMBER: {
    id: 'MPOWER_NUMBER',
    defaultMessage: 'MPower Payment Account Number',
  },
  RAPIDRED_NUMBER: {
    id: 'RAPIDRED_NUMBER',
    defaultMessage: 'RapidRed™ Payment Account Number',
  },
  BLANKETPO_NUMBER: {
    id: 'BLANKETPO_NUMBER',
    defaultMessage: 'Blanket PO Number',
  },
  PAYMENT_TERMS: { id: 'PAYMENT_TERMS', defaultMessage: 'Payment Terms' },
  SORT_BY_MOST_RECENT: {
    id: 'SORT_BY_MOST_RECENT',
    defaultMessage: 'Sort by Most Recent',
  },
  SORT_BY_FREQUENTLY_PURCHASED: {
    id: 'SORT_BY_FREQUENTLY_PURCHASED',
    defaultMessage: 'Sort by Frequently Purchased',
  },
  LAST_PURCHASED: { id: 'LAST_PURCHASED', defaultMessage: 'Last Purchased' },
  VIEW_PRICE_AND_AVAILABILITY: {
    id: 'VIEW_PRICE_AND_AVAILABILITY',
    defaultMessage: 'View Price and Availability',
  },
  PROFORMA_INVOICE_NUMBER: {
    id: 'PROFORMA_INVOICE_NUMBER',
    defaultMessage: 'Proforma Invoice Number',
  },
  TAX_INVOICE_NUMBER: {
    id: 'TAX_INVOICE_NUMBER',
    defaultMessage: 'Tax Invoice Number',
  },
  INVOICE_DATE: { id: 'INVOICE_DATE', defaultMessage: 'Invoice Date' },
  PAYER_NAME: { id: 'PAYER_NAME', defaultMessage: 'Payer Name' },
  INVOICE_TOTAL: { id: 'INVOICE_TOTAL', defaultMessage: 'Invoice Total' },
  PAYMENT_BY_CREDIT_CARD_SUCCESS_MSG: {
    id: 'PAYMENT_BY_CREDIT_CARD_SUCCESS_MSG',
    defaultMessage: 'Thank you. Your invoices were processed.',
  },
  CREDIT_CARD_PAYMENT_FAILED: {
    id: 'CREDIT_CARD_PAYMENT_FAILED',
    defaultMessage: 'Payment failed. Please try again.',
  },
  CREDIT_CARD_TRANSACTION_FAILED: {
    id: 'CREDIT_CARD_TRANSACTION_FAILED',
    defaultMessage:
      'Payment was successful but we are unable to update the transaction.',
  },
  SELECT_SHINHAN_CREDIT_CARD_TYPE_CCTYPE_L0: {
    id: 'SELECT_SHINHAN_CREDIT_CARD_TYPE_CCTYPE_L0',
    defaultMessage: 'Shinhan (LG) research card',
  },
  SELECT_CREDIT_CARD_TYPE_CCTYPE_L1: {
    id: 'SELECT_CREDIT_CARD_TYPE_CCTYPE_L1',
    defaultMessage: 'Credit card',
  },
  SELECT_OTHER_CREDIT_CARD_TYPE_CCTYPE_L2: {
    id: 'SELECT_OTHER_CREDIT_CARD_TYPE_CCTYPE_L2',
    defaultMessage: 'Other credit card',
  },
  SELECT_IBM_RESEARCH_CREDIT_CARD_TYPE_CCCTYPE_K0: {
    id: 'SELECT_IBM_RESEARCH_CREDIT_CARD_TYPE_CCCTYPE_K0',
    defaultMessage: 'IBK research card',
  },
  SELECT_CREDIT_CARD_TYPE_TO_PAY: {
    id: 'SELECT_CREDIT_CARD_TYPE_TO_PAY',
    defaultMessage: 'Select credit card type to pay',
  },
  NO_INDIVIDUAL_INVOICES_AVAILABLE: {
    id: 'NO_INDIVIDUAL_INVOICES_AVAILABLE',
    defaultMessage:
      'The Billing Method used for your organization does not support displaying individual invoices.',
  },
  SELECTED_TOTAL: { id: 'SELECTED_TOTAL', defaultMessage: 'Selected Total' },
  SELECTED_CREDIT_CARD: {
    id: 'SELECTED_CREDIT_CARD',
    defaultMessage: 'Select Credit Card',
  },
  PAYER: { id: 'PAYER', defaultMessage: 'Payer' },
  DEALER_LABEL_REQUESTID: {
    id: 'DEALER_LABEL_REQUESTID',
    defaultMessage: 'Request ID',
  },
  DEALER_LABEL_ORDERNO: {
    id: 'DEALER_LABEL_ORDERNO',
    defaultMessage: 'Order Number',
  },
  DEALER_LABEL_CUSTOMERPO: {
    id: 'DEALER_LABEL_CUSTOMERPO',
    defaultMessage: 'Customer PO',
  },
  DEALER_LABEL_ORGANIZATION: {
    id: 'DEALER_LABEL_ORGANIZATION',
    defaultMessage: 'Organization',
  },
  DEALER_LABEL_ADDRESS: {
    id: 'DEALER_LABEL_ADDRESS',
    defaultMessage: 'Address',
  },
  DEALER_LABEL_CREATED: {
    id: 'DEALER_LABEL_CREATED',
    defaultMessage: 'Created',
  },
  DEALER_LABEL_STATUS: { id: 'DEALER_LABEL_STATUS', defaultMessage: 'Status' },
  DEALER_LABEL_TOTAL: { id: 'DEALER_LABEL_TOTAL', defaultMessage: 'Total' },
  DEALER_REQUEST_STATUS_PENDING: {
    id: 'DEALER_REQUEST_STATUS_PENDING',
    defaultMessage: 'Pending',
  },
  DEALER_REQUEST_STATUS_REJECTED: {
    id: 'DEALER_REQUEST_STATUS_REJECTED',
    defaultMessage: 'Rejected',
  },
  NOT_AVAILABLE: { id: 'NOT_AVAILABLE', defaultMessage: 'Not Available' },
  REQUEST_ID_SAP_NUMBER: {
    id: 'REQUEST_ID_SAP_NUMBER',
    defaultMessage: 'Request ID / SAP Order Number',
  },
  DEALER_REQUEST_STATUS_ALL_REQUESTS: {
    id: 'DEALER_REQUEST_STATUS_ALL_REQUESTS',
    defaultMessage: 'All Requests',
  },
  DEALER_REQUEST_STATUS_APPROVED: {
    id: 'DEALER_REQUEST_STATUS_APPROVED',
    defaultMessage: 'Approved',
  },
  DEALER_REQUEST_STATUS_LOCALLYREJECTED: {
    id: 'DEALER_REQUEST_STATUS_LOCALLYREJECTED',
    defaultMessage: 'Locally Rejected',
  },
  DEALER_REQUEST_STATUS_PARTIALLYAPPROVED: {
    id: 'DEALER_REQUEST_STATUS_PARTIALLYAPPROVED',
    defaultMessage: 'Partially Approved',
  },
  ALL: { id: 'ALL', defaultMessage: 'All' },
  EMPTY: { id: 'EMPTY', defaultMessage: 'Empty' },
  UNKNOWN: { id: 'UNKNOWN', defaultMessage: 'Unknown' },
  IN_PROGRESS: { id: 'IN_PROGRESS', defaultMessage: 'In Progress' },
  COMPLETED: { id: 'COMPLETED', defaultMessage: 'Completed' },
  IN_PROCESS: { id: 'IN_PROCESS', defaultMessage: 'In Process' },
  NEW: { id: 'NEW', defaultMessage: 'New' },
  ON_HOLD: { id: 'ON_HOLD', defaultMessage: 'On Hold' },
  COMPLETE: { id: 'COMPLETE', defaultMessage: 'Complete' },
  CANCELLED: { id: 'CANCELLED', defaultMessage: 'Cancelled' },
  PENDING: { id: 'PENDING', defaultMessage: 'Pending' },
  PROCESSING: { id: 'PROCESSING', defaultMessage: 'Processing' },
  RECEIVED: { id: 'RECEIVED', defaultMessage: 'Received' },
  SHIPPING_IN_PROGRESS: {
    id: 'SHIPPING_IN_PROGRESS',
    defaultMessage: 'Shipping In Progress',
  },
  SHIPPED: {
    id: 'SHIPPED',
    defaultMessage: 'Shipped',
  },
  PARTIALLY_SHIPPED: {
    id: 'PARTIALLY_SHIPPED',
    defaultMessage: 'Partially Shipped',
  },
  PARTIALLY_CANCELLED: {
    id: 'PARTIALLY_CANCELLED',
    defaultMessage: 'Partially Cancelled',
  },
  PARTIALLY_CLOSED: {
    id: 'PARTIALLY_CLOSED',
    defaultMessage: 'Partially Closed',
  },
  PARTIALLY_RECEIVED: {
    id: 'PARTIALLY RECEIVED',
    defaultMessage: 'Partially Received',
  },
  CLOSED: {
    id: 'CLOSED',
    defaultMessage: 'Closed',
  },
  DAYS: {
    id: 'DAYS',
    defaultMessage: 'Days',
  },
  WIMS_ORDER_STATUS_H: { id: 'WIMS_ORDER_STATUS_H', defaultMessage: 'Error' },
  WIMS_ORDER_STATUS_D: { id: 'WIMS_ORDER_STATUS_D', defaultMessage: 'Denied' },
  WIMS_ORDER_STATUS_MAP: {
    id: 'WIMS_ORDER_STATUS_MAP',
    defaultMessage: 'Processing',
  },
  WIMS_ORDER_STATUS_MC: {
    id: 'WIMS_ORDER_STATUS_MC',
    defaultMessage: 'Cancelled',
  },
  WIMS_ORDER_STATUS_MG: {
    id: 'WIMS_ORDER_STATUS_MG',
    defaultMessage: 'Pending',
  },
  WIMS_ORDER_STATUS_MOC: {
    id: 'WIMS_ORDER_STATUS_MOC',
    defaultMessage: 'Closed',
  },
  WIMS_ORDER_STATUS_MPC: {
    id: 'WIMS_ORDER_STATUS_MPC',
    defaultMessage: 'Partially Cancelled',
  },
  WIMS_ORDER_STATUS_MPOC: {
    id: 'WIMS_ORDER_STATUS_MPOC',
    defaultMessage: 'Partially Closed',
  },
  WIMS_ORDER_STATUS_MPRE: {
    id: 'WIMS_ORDER_STATUS_MPRE',
    defaultMessage: 'Partially Received',
  },
  WIMS_ORDER_STATUS_MPS: {
    id: 'WIMS_ORDER_STATUS_MPS',
    defaultMessage: 'Partially Shipped',
  },
  WIMS_ORDER_STATUS_MRE: {
    id: 'WIMS_ORDER_STATUS_MRE',
    defaultMessage: 'Received',
  },
  WIMS_ORDER_STATUS_MS: {
    id: 'WIMS_ORDER_STATUS_MS',
    defaultMessage: 'Shipped',
  },
  WIMS_ORDER_STATUS_MSINP: {
    id: 'WIMS_ORDER_STATUS_MSINP',
    defaultMessage: 'Shipping in Progress',
  },
  WIMS_ORDER_STATUS_IN_PROCESS: {
    id: 'WIMS_ORDER_STATUS_IN_PROCESS',
    defaultMessage: 'In Process',
  },
  WIMS_ORDER_STATUS_COMPLETE: {
    id: 'WIMS_ORDER_STATUS_COMPLETE',
    defaultMessage: 'Complete',
  },
  PARTIALLY_COMPLETED: {
    id: 'PARTIALLY_COMPLETED',
    defaultMessage: 'Partially Completed',
  },
  WIMS_QUOTE_STATUS_G: { id: 'WIMS_QUOTE_STATUS_G', defaultMessage: 'Pending' },
  ORDER_RETURN_SUBMITTED: {
    id: 'ORDER_RETURN_SUBMITTED',
    defaultMessage:
      'Your return request has been successfully submitted. You will be notified once we confirm your request.',
  },
  ORDER_CANCEL_SUBMITTED: {
    id: 'ORDER_CANCEL_SUBMITTED',
    defaultMessage:
      'Your cancel request has been successfully submitted. You will be notified once we confirm your request.',
  },
  PAYMENT_BREAKDOWN: {
    id: 'PAYMENT_BREAKDOWN',
    defaultMessage: 'Payment Breakdown',
  },
  CARD_TYPE: { id: 'CARD_TYPE', defaultMessage: 'Card Type' },
  APPROVAL_SUCCESSFUL: {
    id: 'APPROVAL_SUCCESSFUL',
    defaultMessage: 'Approval Successful',
  },
  APPROVAL_FAILED: { id: 'APPROVAL_FAILED', defaultMessage: 'Approval Failed' },
  APPROVAL_NUMBER: { id: 'APPROVAL_NUMBER', defaultMessage: 'Approval Number' },
  APPROVAL_TIME: { id: 'APPROVAL_TIME', defaultMessage: 'Approval Time' },
  PRINT_RECEIPT: { id: 'PRINT_RECEIPT', defaultMessage: 'Print Receipt' },
  PAY_INVOICES: { id: 'PAY_INVOICES', defaultMessage: 'Pay Invoices' },
  PAYMENT_RESULT: { id: 'PAYMENT_RESULT', defaultMessage: 'Payment Result' },
  SL_NO: { id: 'SL_NO', defaultMessage: 'No' },
  RETURN_INITIATED: {
    id: 'RETURN_INITIATED',
    defaultMessage: 'Return Initiated',
  },
  RESUBMIT_ORDER: { id: 'RESUBMIT_ORDER', defaultMessage: 'Resubmit Order' },
  RESUBMIT_QUOTE: { id: 'RESUBMIT_QUOTE', defaultMessage: 'Resubmit Quote' },
  REJECT_QUOTE: { id: 'REJECT_QUOTE', defaultMessage: 'Reject Quote' },
  CONFIRM_QUOTE: {
    id: 'CONFIRM_QUOTE',
    defaultMessage: 'Confirm Quote',
  },
  CONFIRM_QUOTE_MSG: {
    id: 'CONFIRM_QUOTE_MSG',
    defaultMessage:
      'Have you verified the quote was completely transferred to SAP',
  },
  CONFIRM_ORDER_MSG: {
    id: 'CONFIRM_ORDER_MSG',
    defaultMessage:
      'Have you verified the order was completely transferred to SAP',
  },
  CONFIRM_ORDER: {
    id: 'CONFIRM_ORDER',
    defaultMessage: 'Confirm Order',
  },
  CONFIRM_CART_ITEMS: {
    id: 'CONFIRM_CART_ITEMS',
    defaultMessage: 'Confirm the number of items in your cart',
  },
  CONFIRM_CART_ITEMS_MSG: {
    id: 'CONFIRM_CART_ITEMS_MSG',
    defaultMessage:
      'The number of items in your cart has changed. This occurs when multiple users share the same account credentials or when a user add products to a cart on multiple devices. Please confirm that the number of items in your cart are correct before checking out.',
  },
  RESUBMIT_ORDER_MSG: {
    id: 'RESUBMIT_ORDER_MSG',
    defaultMessage:
      'Have you verified the order does not exist in the SAP system for this customer?',
  },
  RESUBMIT_QUOTE_MSG: {
    id: 'RESUBMIT_QUOTE_MSG',
    defaultMessage:
      'Have you verified the quote does not exist in the SAP system for this customer?',
  },
  REJECT_ORDER_MSG: {
    id: 'REJECT_ORDER_MSG',
    defaultMessage: 'Are you sure want to reject this order?',
  },
  REJECT_ORDER: {
    id: 'REJECT_ORDER',
    defaultMessage: 'Reject Order',
  },
  REJECT_QUOTE_MSG: {
    id: 'REJECT_QUOTE_MSG',
    defaultMessage: 'Are you sure want to reject this quote?',
  },
  QUOTE_VERIFICATION_TITLE: {
    id: 'QUOTE_VERIFICATION_TITLE',
    defaultMessage: 'QUOTE VERIFICATION',
  },
  ORDER_VERIFICATION_TITLE: {
    id: 'ORDER_VERIFICATION_TITLE',
    defaultMessage: 'ORDER VERIFICATION',
  },
  ORDER_REJECT_TITLE: {
    id: 'ORDER_REJECT_TITLE',
    defaultMessage: 'REJECT ORDER',
  },
  QUOTE_REJECT_TITLE: {
    id: 'QUOTE_REJECT_TITLE',
    defaultMessage: 'REJECT QUOTE',
  },
  ENTER_SAP_ORDER: {
    id: 'ENTER_SAP_ORDER',
    defaultMessage: 'Enter SAP order',
  },
  ENTER_SAP_ORDER_MSG: {
    id: 'ENTER_SAP_ORDER_MSG',
    defaultMessage: 'Please enter the SAP order number',
  },
  ENTER_MANUAL_SAP_ORDER: {
    id: 'ENTER_MANUAL_SAP_ORDER',
    defaultMessage: 'Enter Manual Order',
  },
  ENTER_MANUAL_SAP_ORDER_MSG: {
    id: 'ENTER_MANUAL_SAP_ORDER_MSG',
    defaultMessage: 'Enter the SAP order number',
  },
  ENTER_MANUAL_SAP_QUOTE_MSG: {
    id: 'ENTER_MANUAL_SAP_QUOTE_MSG',
    defaultMessage: 'Enter the SAP quote number',
  },
  CONFIRM_SAP_ORDER: { id: 'CONFIRM_SAP_ORDER', defaultMessage: 'Confirm' },
  DETAILS: { id: 'DETAILS', defaultMessage: 'Details' },
  SEARCH_INPUT_PLACEHOLDER: {
    id: 'SEARCH_INPUT_PLACEHOLDER',
    defaultMessage: '(T1503-25G, W4502-100G...)',
  },
  SEARCH_PRODUCTS_BY_SKU: {
    id: 'SEARCH_PRODUCTS_BY_SKU',
    defaultMessage: 'Search Products by SKU',
  },
  BUY_IT_AGAIN_SEARCH_RESULTS: {
    id: 'BUY_IT_AGAIN_SEARCH_RESULTS',
    defaultMessage: `Showing {count, plural,
      =0 {0 results}
      one {1 result}
      two {2 results}
      few {{fromTo} results of {count}}
      many {{fromTo} results of {count}}
      other {{fromTo} results of {count}}
    } for {searchTerm} within Buy It Again`,
  },
  X_OF_Y_SHIPPED: {
    id: 'X_OF_Y_SHIPPED',
    defaultMessage: '{x} of {y} Shipped',
  },
  SHIPPED_ON: {
    id: 'SHIPPED_ON',
    defaultMessage: 'Shipped on',
  },
  ESTIMATED_TO_SHIP_ON: {
    id: 'ESTIMATED_TO_SHIP_ON',
    defaultMessage: 'Estimated to ship on',
  },
  REJECTED: {
    id: 'REJECTED',
    defaultMessage: 'Rejected',
  },
  DENIED: {
    id: 'DENIED',
    defaultMessage: 'Denied',
  },
  ORDER_NUMBER_TAMPERING: {
    id: 'ORDER_NUMBER_TAMPERING',
    defaultMessage:
      'Sorry, your temporary order number can not be used here. Please use your Sales Document number when available.',
  },
  ORDER_DETAILS_UNAVAILABLE: {
    id: 'ORDER_DETAILS_UNAVAILABLE',
    defaultMessage:
      'Details for this order are currently unavailable. Please try again later.',
  },
  ADDITIONAL_DETAILS: {
    id: 'ADDITIONAL_DETAILS',
    defaultMessage: 'Additional Details',
  },
  SHIPMENT_SUMMARY: {
    id: 'SHIPMENT_SUMMARY',
    defaultMessage: 'Shipment Summary',
  },
  SAP_DOC: {
    id: 'SAP_DOC',
    defaultMessage: 'SAP Doc.',
  },
  ORDER_NO: {
    id: 'ORDER_NO',
    defaultMessage: 'Order No.',
  },
  TRANS_ID: {
    id: 'TRANS_ID',
    defaultMessage: 'Trans ID',
  },
  TRANSACTION_DATE: {
    id: 'TRANSACTION_DATE',
    defaultMessage: 'Transaction Date',
  },
  PAYMENT_HISTORY_STATUS_WARNING: {
    id: 'PAYMENT_HISTORY_STATUS_WARNING',
    defaultMessage:
      'Payment successful, but we are unable to update your records at this time. Please check back later.',
  },
  PAYMENT_HISTORY_STATUS_ERROR: {
    id: 'PAYMENT_HISTORY_STATUS_ERROR',
    defaultMessage: 'Payment failed. Please try again.',
  },
  PAYMENT_HISTORY_STATUS_SUCCESS: {
    id: 'PAYMENT_HISTORY_STATUS_SUCCESS',
    defaultMessage: 'Payment successful.',
  },
  PAYMENT_HISTORY_STATUS_SUCCESS_ID: {
    id: 'PAYMENT_HISTORY_STATUS_SUCCESS_ID',
    defaultMessage: 'Payment successful for Transaction ID {transactionId}.',
  },
  PAYMENT_HISTORY_STATUS_FAILURE_ID: {
    id: 'PAYMENT_HISTORY_STATUS_FAILURE_ID',
    defaultMessage:
      'Payment failed for Transaction ID {transactionId}. {errorMessageText} Please try again.',
  },
  MPAY_ERROR_INVALID_AMOUNT: {
    id: 'MPAY_ERROR_INVALID_AMOUNT',
    defaultMessage: 'Invalid amount.',
  },
  MPAY_ERROR_EXTERNAL_ERROR: {
    id: 'MPAY_ERROR_EXTERNAL_ERROR',
    defaultMessage: 'External Error.',
  },
  MPAY_STATUS_FAILED: {
    id: 'MPAY_STATUS_FAILED',
    defaultMessage: 'Failed',
  },
  MPAY_STATUS_SUCCESS: {
    id: 'MPAY_STATUS_SUCCESS',
    defaultMessage: 'Success',
  },
  MPAY_STATUS_PENDING: {
    id: 'MPAY_STATUS_PENDING',
    defaultMessage: 'Pending',
  },
  MPAY_STATUS_NOT_CLEAR: {
    id: 'MPAY_STATUS_NOT_CLEAR',
    defaultMessage: 'Not Clear',
  },
  MPAY_STATUS_PARTIALLY_COMPLETE: {
    id: 'MPAY_STATUS_PARTIALLY_COMPLETE',
    defaultMessage: 'Partially Complete',
  },
  MPAY_STATUS_NOT_CLEAR_CUSTOMER_SERVICE: {
    id: 'MPAY_STATUS_NOT_CLEAR_CUSTOMER_SERVICE',
    defaultMessage:
      'Invoice failed to process, please contact {customerService}',
  },
  INVOICE_STATUS_OPEN_DESCRIPTION: {
    id: 'INVOICE_STATUS_OPEN_DESCRIPTION',
    defaultMessage: 'Invoices submitted for payment',
  },
  INVOICE_STATUS_IN_PROCESS_DESCRIPTION: {
    id: 'INVOICE_STATUS_IN_PROCESS_DESCRIPTION',
    defaultMessage: 'Payment under process',
  },
  INVOICE_STATUS_FAILED_DESCRIPTION: {
    id: 'INVOICE_STATUS_FAILED_DESCRIPTION',
    defaultMessage: 'Payment failed',
  },
  INVOICE_STATUS_SUCCESS_DESCRIPTION: {
    id: 'INVOICE_STATUS_SUCCESS_DESCRIPTION',
    defaultMessage: 'Payment completed',
  },
  INVOICE_STATUS_COMPLETE_DESCRIPTION: {
    id: 'INVOICE_STATUS_COMPLETE_DESCRIPTION',
    defaultMessage: 'Invoice processed',
  },
  INVOICE_STATUS_PENDING_DESCRIPTION: {
    id: 'INVOICE_STATUS_PENDING_DESCRIPTION',
    defaultMessage: 'Payment completed and invoices under process',
  },
  MPAY_STATUS_NOT_CLEARED: {
    id: 'MPAY_STATUS_NOT_CLEARED',
    defaultMessage: 'Not Cleared',
  },
  LIST_DEADLINE: {
    id: 'LIST_DEADLINE',
    defaultMessage: 'List Deadline',
  },
  LIST_DEADLINE_DESCRIPTION: {
    id: 'LIST_DEADLINE_DESCRIPTION',
    defaultMessage:
      'Setting a deadline will notify members of the timeframe for contributing to the list. Beyond the deadline, members will not be able to add or remove items from the list. This deadline can be edited at any time by the Owner of the List.',
  },
  AUTOMATED_REMINDERS: {
    id: 'AUTOMATED_REMINDERS',
    defaultMessage: 'Automated Reminders',
  },
  AUTOMATED_REMINDERS_DESCRIPTION: {
    id: 'AUTOMATED_REMINDERS_DESCRIPTION',
    defaultMessage:
      'Notify members via email of the timeframe for contributing to the list. In this set timeframe, members who have not marked themselves as done will receive an email reminder to login and make their contributions to the list. Reminders must be at least 24 hours before a deadline.',
  },
  RECOMMENDED: {
    id: 'RECOMMENDED',
    defaultMessage: 'Recommended',
  },
  X_BEFORE_LIST_DEADLINE: {
    id: 'X_BEFORE_LIST_DEADLINE',
    defaultMessage: '{timeRemaining} before List Deadline',
  },
  TWENTY_FOUR_HOURS: {
    id: 'TWENTY_FOUR_HOURS',
    defaultMessage: '24 hours',
  },
  THREE_DAYS: {
    id: 'THREE_DAYS',
    defaultMessage: '3 days',
  },
  ONE_WEEK: {
    id: 'ONE_WEEK',
    defaultMessage: '1 week',
  },
  REMIND_MEMBERS_DESCRIPTION: {
    id: 'REMIND_MEMBERS_DESCRIPTION',
    defaultMessage: 'Remind members with a one time email prior to deadline',
  },
  REMIND_MEMBERS_DESCRIPTION_ALT: {
    id: 'REMIND_MEMBERS_DESCRIPTION_ALT',
    defaultMessage: 'Remind members who have not marked themselves as done',
  },
  READ_ABOVE_FOR_MORE_INFO: {
    id: 'READ_ABOVE_FOR_MORE_INFO',
    defaultMessage: 'Read above for more info',
  },
  ADD_DEADLINE: {
    id: 'ADD_DEADLINE',
    defaultMessage: 'Add deadline',
  },
  DEFAULT_TIME_DEADLINE: {
    id: 'DEFAULT_TIME_DEADLINE',
    defaultMessage: 'Default Time Deadline:',
  },
  LIST_DEADLINE_EXPIRED_MEMBER: {
    id: 'LIST_DEADLINE_EXPIRED_MEMBER',
    defaultMessage:
      'The deadline for this list has expired. Contact the owner of the list for inquiries.',
  },
  LIST_DEADLINE_EXPIRED_OWNER: {
    id: 'LIST_DEADLINE_EXPIRED_OWNER',
    defaultMessage:
      'The deadline for this list has expired. Contributors cannot add or remove items. Extend the deadline to allow for edits to the list.',
  },
  CONTACT_LIST_OWNER: {
    id: 'CONTACT_LIST_OWNER',
    defaultMessage: 'Contact List Owner',
  },
  NO_DEADLINE_SET: { id: 'NO_DEADLINE_SET', defaultMessage: 'No deadline set' },
  AT_TIME: { id: 'AT_TIME', defaultMessage: 'at {time}' },
  TDS_INFO: {
    id: 'TDS_INFO',
    defaultMessage: 'Limited to 20% of Invoice Amount',
  },
  RETURN_PRODUCT: {
    id: 'RETURN_PRODUCT',
    defaultMessage: 'Return Product',
  },
  FULFILMENT_DELIVERY_DELAYED: {
    id: 'FULFILMENT_DELIVERY_DELAYED',
    defaultMessage: 'Fulfilment and delivery delayed',
  },
  DELAYED: {
    id: 'DELAYED',
    defaultMessage: 'Delayed',
  },
  INVALID_CREDIT_CARD_INFO: {
    id: 'INVALID_CREDIT_CARD_INFO',
    defaultMessage:
      'Invalid card details. Please update the card information, or try a different credit card.',
  },
  FAILED_TO_PROCESS_PAYMENT: {
    id: 'FAILED_TO_PROCESS_PAYMENT',
    defaultMessage:
      'Payment failed for Transaction ID {transactionId}. {errorMessageText} Please try again.',
  },
  TECHNICAL_DIFFICULTIES: {
    id: 'TECHNICAL_DIFFICULTIES',
    defaultMessage:
      'We are currently experiencing some technical difficulties. Please try again later.',
  },
})

export default messages
